const careerNp = {
  breadcrumbs: { home: 'गृहपृष्ठ', career: 'करियर' },
  hero: {
    title: 'आफ्नो सपना करियर सुरु गर्नुहोस्',
    subtitle: 'ग्रामिण बजारमा सामेल हुनुहोस् र नेपालको ग्रामीण वाणिज्यलाई डिजिटल युगतिर रूपान्तरण गर्न सहयोग गर्नुहोस्'
  },
  companyStats: [
    { value: '५००+', label: 'कर्मचारी' },
    { value: '१०+', label: 'कार्यालय' },
    { value: '९८%', label: 'कर्मचारी सन्तुष्टि' },
    { value: '१००+', label: 'तालिम कार्यक्रम' }
  ],
  jobsSection: { title: 'खुला पदहरू', subtitle: 'हामीसँग काम गर्नुहोस् र आफ्नो करियर बढाउनुहोस्' },
  labels: {
    featured: 'विशेष',
    postedSuffix: 'प्रकाशित',
    salary: 'तलब',
    deadline: 'आवेदन गर्ने अन्तिम मिति'
  },
  buttons: {
    viewDetails: 'विवरण हेर्नुहोस्',
    apply: 'आवेदन गर्नुहोस्',
    cancel: 'रद्द गर्नुहोस्',
    submit: 'आवेदन पठाउनुहोस्',
    contact: 'सम्पर्क गर्नुहोस्'
  },
  cta: {
    title: 'उपयुक्त पद भेटिएन?',
    subtitle: 'हामीलाई सम्पर्क गर्नुहोस्। नयाँ अवसर बारेमा हामी सूचित गर्नेछौं।',
    contact: 'सम्पर्क गर्नुहोस्'
  },
  form: {
    titleSuffix: ' - आवेदन फारम',
    name: 'नाम',
    email: 'इमेल',
    phone: 'फोन',
    education: 'शैक्षिक योग्यता',
    experience: 'कार्य अनुभव',
    uploadResume: 'रिज्युमे अपलोड गर्नुहोस् (PDF, DOC, DOCX)'
  },
  snackbar: { success: 'तपाईंको आवेदन सफलतापूर्वक पठाइयो। हामी छिट्टै सम्पर्क गर्छौं।' }
};

export default careerNp;


